import styled from "styled-components";

export const StyledUsers = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledUsersContent = styled.div`
    padding: 40px;
    height: 100%;
`;
